import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../../base.component';
import {DetailsOptions, DynamicField} from './options/details.options';
import {MatDialogRef} from '@angular/material/dialog';
import {SnackBarUtil} from '../../../../util/snack.bar.util';
import {DataResponse} from '../../../../network/service/data.response';

@Component({
  selector: 'app-details',
  standalone: false,
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent extends BaseComponent implements OnInit {
  detailsOptions = new DetailsOptions();
  details?: any;
  dynamicFields: DynamicField[] = [];
  public configData: any;
  public editorFields: DynamicField[] = [];
  public fileChooserFields: DynamicField[] = [];
  public colorFields: DynamicField[] = [];
  public inputFields: DynamicField[] = [];
  public checkboxFields: DynamicField[] = [];
  public objectFields: DynamicField[] = [];
  public arrayFields: DynamicField[] = [];

  constructor(injector: Injector, private matDialogRef: MatDialogRef<DetailsComponent>) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.detailsOptions.fields && this.detailsOptions.fields.length > 0) {
      this.dynamicFields = this.detailsOptions.fields;
      this.editorFields = this.dynamicFields.filter(f => f.type === 'editor');
      this.fileChooserFields = this.dynamicFields.filter(f => f.type === 'file-chooser');
      this.colorFields = this.dynamicFields.filter(f => f.type === 'color');
      this.objectFields = this.dynamicFields.filter(f => f.type === 'object');
      this.arrayFields = this.dynamicFields.filter(f => f.type === 'array');
      this.inputFields = this.dynamicFields.filter(f => f.type !== 'editor' && f.type !== 'file-chooser' && f.type !== 'color' && f.type !== 'object' && f.type !== 'array');
    }
  }

  upload(file: any, callback: any) {
    if (file) {
      if (file instanceof File) {
        let formData = new FormData();
        formData.append('File', file);
        this.serviceApi.upload(formData).subscribe((res: DataResponse<any>) => {
          if (res.success) {
            callback(res.data.dataValues.FileId);
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        callback(file.name);
      }
    } else {
      callback(null);
    }
  }

  uploadField(field: DynamicField, callback: any) {
    if (field.type === 'file-chooser' && field.value) {
      if (field.isMultiple) {
        if (Array.isArray(field.value)) {
          let uploadedCount = 0;
          let uploadedFiles: string[] = [];
          field.value.forEach((file: any, index: number) => {
            this.upload(file, (fileId: string) => {
              uploadedFiles[index] = fileId;
              uploadedCount++;
              if (uploadedCount === field.value.length) {
                callback(uploadedFiles);
              }
            });
          });
        } else {
          callback([]);
        }
      } else {
        if (Array.isArray(field.value) && field.value.length > 0) {
          this.upload(field.value[0], (fileId: string) => {
            callback(fileId);
          });
        } else if (Array.isArray(field.value) && field.value.length === 0) {
          callback(null);
        } else {
          this.upload(field.value, (fileId: string) => {
            callback(fileId);
          });
        }
      }
    } else {
      callback(field.value);
    }
  }

  onSubmitClicked() {
    const result: any = {};
    let fieldsToProcess = this.dynamicFields.length;
    let processedFields = 0;
    this.dynamicFields.forEach(field => {
      if (field.type === 'object') {
        // برای فیلدهای آبجکت، مقادیر را از objectFields جمع‌آوری می‌کنیم
        this.processObjectField(field, (objectValue: any) => {
          result[field.label] = objectValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            this.detailsOptions.onDetailsSelected(result);
            this.noAction();
          }
        });
      } else if (field.type === 'array') {
        // برای فیلدهای آرایه، مقادیر را مستقیماً استفاده می‌کنیم
        this.processArrayField(field, (arrayValue: any) => {
          result[field.label] = arrayValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            this.detailsOptions.onDetailsSelected(result);
            this.noAction();
          }
        });
      } else {
        this.uploadField(field, (uploadedValue: any) => {
          result[field.label] = uploadedValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            this.detailsOptions.onDetailsSelected(result);
            this.noAction();
          }
        });
      }
    });
  }

  addArrayItem(field: DynamicField) {
    if (!field.value) {
      field.value = [];
    }
    const newItem: any = {};
    if (field.arrayFields) {
      field.arrayFields.forEach(arrayField => {
        newItem[arrayField.label] = '';
      });
    }
    field.value.push(newItem);
  }

  removeArrayItem(field: DynamicField, index: number) {
    if (field.value && field.value.length > index) {
      field.value.splice(index, 1);
    }
  }

  noAction() {
    this.matDialogRef.close();
  }

  private processObjectField(field: DynamicField, callback: (value: any) => void) {
    if (!field.objectFields) {
      callback({});
      return;
    }
    const objectValue: any = {};
    let fieldsToProcess = field.objectFields.length;
    let processedFields = 0;
    field.objectFields.forEach(objField => {
      if (objField.type === 'object' && objField.objectFields) {
        // برای فیلدهای تو در تو
        this.processNestedObjectField(objField, (nestedValue: any) => {
          objectValue[objField.label] = nestedValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            callback(objectValue);
          }
        });
      } else if (objField.type === 'file-chooser') {
        this.uploadField(objField, (uploadedValue: any) => {
          objectValue[objField.label] = uploadedValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            callback(objectValue);
          }
        });
      } else {
        objectValue[objField.label] = objField.value;
        processedFields++;
        if (processedFields === fieldsToProcess) {
          callback(objectValue);
        }
      }
    });
  }

  private processNestedObjectField(field: DynamicField, callback: (value: any) => void) {
    if (!field.objectFields) {
      callback({});
      return;
    }
    const nestedObjectValue: any = {};
    let fieldsToProcess = field.objectFields.length;
    let processedFields = 0;
    field.objectFields.forEach(nestedField => {
      if (nestedField.type === 'file-chooser') {
        this.uploadField(nestedField, (uploadedValue: any) => {
          nestedObjectValue[nestedField.label] = uploadedValue;
          processedFields++;
          if (processedFields === fieldsToProcess) {
            callback(nestedObjectValue);
          }
        });
      } else {
        nestedObjectValue[nestedField.label] = nestedField.value;
        processedFields++;
        if (processedFields === fieldsToProcess) {
          callback(nestedObjectValue);
        }
      }
    });
  }

  private processArrayField(field: DynamicField, callback: (value: any) => void) {
    if (!field.value || !Array.isArray(field.value)) {
      callback([]);
      return;
    }
    const arrayValue: any[] = [];
    let itemsToProcess = field.value.length;
    let processedItems = 0;
    if (itemsToProcess === 0) {
      callback(arrayValue);
      return;
    }
    field.value.forEach((item: any, index: number) => {
      const processedItem: any = {};
      let fieldsToProcess = field.arrayFields?.length || 0;
      let processedFields = 0;
      if (fieldsToProcess === 0) {
        arrayValue[index] = item;
        processedItems++;
        if (processedItems === itemsToProcess) {
          callback(arrayValue);
        }
        return;
      }
      field.arrayFields?.forEach(arrayField => {
        if (arrayField.type === 'file-chooser') {
          const fieldWithValue = {
            ...arrayField,
            value: item[arrayField.label]
          };
          this.uploadField(fieldWithValue, (uploadedValue: any) => {
            processedItem[arrayField.label] = uploadedValue;
            processedFields++;
            if (processedFields === fieldsToProcess) {
              arrayValue[index] = processedItem;
              processedItems++;
              if (processedItems === itemsToProcess) {
                callback(arrayValue);
              }
            }
          });
        } else {
          processedItem[arrayField.label] = item[arrayField.label];
          processedFields++;
          if (processedFields === fieldsToProcess) {
            arrayValue[index] = processedItem;
            processedItems++;
            if (processedItems === itemsToProcess) {
              callback(arrayValue);
            }
          }
        }
      });
    });
  }
}
